import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import BigGames from "./pages/BigGames";
import Research from "./pages/Research";
import TalkToUs from "./pages/TalkToUs";
import Results from "./pages/Results";
import Quiz from "./pages/Quiz";
import Admin from "./pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
          else el.scrollIntoView({ behavior: "smooth" });
        }
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/big-games" element={<BigGames />} />
          <Route path="/research" element={<Research />} />
          <Route path="/talk-to-us" element={<TalkToUs />} />
          <Route path="/results" element={<Results />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
